export class NiveauQualification {
    id: number;
    name: string;
}


